import { render } from "./Tournament.vue?vue&type=template&id=6307f280&scoped=true&ts=true"
import script from "./Tournament.vue?vue&type=script&lang=ts"
export * from "./Tournament.vue?vue&type=script&lang=ts"

import "./Tournament.vue?vue&type=style&index=0&id=6307f280&scoped=true&lang=scss"

import exportComponent from "/home/deploy/2290059a64cb5b6694a8/Front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6307f280"]])

export default __exports__